import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";

import styles from "./io-sync.module.scss";

const IOIntegrationFields = ({ requiresBatch, productionBatch, expirationDate, onChange }) => {
	const handleBatchRequirementChange = (requires) => {
		onChange("requiresBatch", requires ? 1 : 0);
		if (!requires) onChange("productionBatch", "");
	};

	return (
		<div className={styles.fieldsContainer}>
			<p className={styles.codesLabel}>Configuración adicional</p>

			<CustomInputSwitch
				label="Requiere lote de producción"
				value={!!requiresBatch}
				onChange={handleBatchRequirementChange}
				optionLeft="No"
				optionRight="Sí"
			/>

			{!!requiresBatch && (
				<div className={styles.fieldsGrid}>
					<CustomInputText
						label="Lote de producción"
						value={productionBatch || ""}
						onChange={(value) => onChange("productionBatch", value)}
						placeholder="Ej: L123456"
					/>
					<CustomInputText
						label="Fecha de vencimiento"
						type="date"
						value={expirationDate || ""}
						onChange={(value) => onChange("expirationDate", value)}
					/>
				</div>
			)}
		</div>
	);
};

export default IOIntegrationFields;
